var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-2y",
                    defaultEnd: "2M",
                    label: "LBL0010103",
                    name: "promulgationPeriod",
                  },
                  model: {
                    value: _vm.searchParam.promulgationPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "promulgationPeriod", $$v)
                    },
                    expression: "searchParam.promulgationPeriod",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-2y",
                    defaultEnd: "2M",
                    label: "시행기간",
                    name: "enforcementPeriod",
                  },
                  model: {
                    value: _vm.searchParam.enforcementPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "enforcementPeriod", $$v)
                    },
                    expression: "searchParam.enforcementPeriod",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.curHistoryItems,
                    itemText: "codeName",
                    itemValue: "code",
                    type: "search",
                    label: "현행연혁코드",
                    name: "curHistoryCode",
                  },
                  model: {
                    value: _vm.searchParam.curHistoryCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "curHistoryCode", $$v)
                    },
                    expression: "searchParam.curHistoryCode",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.lawTypeItmes,
                    itemText: "codeName",
                    itemValue: "code",
                    type: "search",
                    label: "법령 구분",
                    name: "lawClassName",
                  },
                  model: {
                    value: _vm.searchParam.lawClassName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "lawClassName", $$v)
                    },
                    expression: "searchParam.lawClassName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-field", {
                  attrs: { type: "user", label: "담당자", name: "userId" },
                  model: {
                    value: _vm.searchParam.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "userId", $$v)
                    },
                    expression: "searchParam.userId",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          attrs: {
            title: "LBL0010096",
            tableId: "safetyControlDangerous",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            customTrClass: _vm.setTrClass,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "reasonText" && props.row[col.name]
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "cursor-pointer text-grey-9",
                            staticStyle: {
                              "max-width": "250px",
                              display: "-webkit-box",
                              "-webkit-box-orient": "vertical",
                              "line-clamp": "2",
                              overflow: "hidden",
                            },
                          },
                          [
                            _c("q-tooltip", [_vm._v("재개정사유 상세")]),
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  dense: "",
                                  icon: "article",
                                  color: "blue-grey-5",
                                  size: "sm",
                                },
                              },
                              [
                                _c(
                                  "q-popup-proxy",
                                  {
                                    attrs: {
                                      "transition-show": "scale",
                                      "transition-hide": "scale",
                                    },
                                  },
                                  [
                                    _c(
                                      "q-card",
                                      {
                                        staticClass: "scroll",
                                        staticStyle: {
                                          width: "500px",
                                          "max-width": "90vw",
                                          "max-height": "50vh",
                                        },
                                      },
                                      [
                                        _c(
                                          "q-card-section",
                                          {
                                            staticClass:
                                              "bg-blue-grey-1 sticky-top",
                                            staticStyle: { "z-index": "1" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle2 text-weight-bold text-blue-9",
                                              },
                                              [
                                                _c("q-icon", {
                                                  staticClass: "q-mr-xs",
                                                  attrs: {
                                                    name: "info",
                                                    size: "xs",
                                                  },
                                                }),
                                                _vm._v(" 재개정사유 상세 "),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c("q-separator"),
                                        _c("q-card-section", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-body2",
                                              staticStyle: {
                                                "white-space": "pre-wrap",
                                                "word-break": "keep-all",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(props.row.reasonText) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" " + _vm._s(props.row.reasonText) + " "),
                            _c(
                              "q-popup-proxy",
                              {
                                attrs: {
                                  "transition-show": "scale",
                                  "transition-hide": "scale",
                                },
                              },
                              [
                                _c(
                                  "q-card",
                                  {
                                    staticClass: "scroll",
                                    staticStyle: {
                                      width: "500px",
                                      "max-width": "90vw",
                                      "max-height": "50vh",
                                    },
                                  },
                                  [
                                    _c(
                                      "q-card-section",
                                      {
                                        staticClass:
                                          "bg-blue-grey-1 sticky-top",
                                        staticStyle: { "z-index": "1" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-subtitle2 text-weight-bold text-blue-9",
                                          },
                                          [
                                            _c("q-icon", {
                                              staticClass: "q-mr-xs",
                                              attrs: {
                                                name: "info",
                                                size: "xs",
                                              },
                                            }),
                                            _vm._v(" 재개정사유 상세 "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c("q-separator"),
                                    _c("q-card-section", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-body2",
                                          staticStyle: {
                                            "white-space": "pre-wrap",
                                            "word-break": "keep-all",
                                            "line-height": "1.6",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row.reasonText) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  col.name === "oldAndNew" ||
                  (col.name === "custom" && props.row.lawLink)
                    ? [
                        _c("q-btn", {
                          staticClass: "tableinnerBtn",
                          attrs: {
                            flat: "",
                            icon: "launch",
                            align: "center",
                            color: "blue-6",
                            label: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.linkClick(props, col)
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }